import {createSlice} from "@reduxjs/toolkit";
import {
    initialState,
    resetItemState,
    startCall,
    catchError,
    itemFetched,
    itemsFetched,
    itemCreated,
    itemUpdated,
    itemDeleted,
    saveDone,
    STATE_INITIAL, STATE_FETCHING, STATE_FETCHED, getError, STATE_ERROR
} from "../../../../../_intesys/_helpers";

const initialVideoSignatureTypesState = {
    state: STATE_INITIAL,
    error: null,
    data: undefined,
};


export const videosSlice = createSlice({
    name: "videos",
    initialState: {
        ...initialState,

        videoSignatureTypes: {},
    },
    reducers: {
        resetItemState: resetItemState,
        saveDone: saveDone,
        catchError: catchError,
        startCall: startCall,
        itemsFetched: itemsFetched,
        itemFetched: itemFetched,
        itemCreated: itemCreated,
        itemUpdated: itemUpdated,
        itemDeleted: itemDeleted,

        getVideoSignatureTypesStart: (state, action) => {
            const {key} = action.payload;
            if (state.videoSignatureTypes[key] === undefined) {
                state.videoSignatureTypes[key] = {...initialVideoSignatureTypesState};
            }
            state.videoSignatureTypes[key].state = STATE_FETCHING;
        },
        getVideoSignatureTypesDone: (state, action) => {
            const {key} = action.payload;

            state.videoSignatureTypes[key].state = STATE_FETCHED;
            state.videoSignatureTypes[key].data = action.payload.data;
            state.videoSignatureTypes[key].error = null;
        },
        getVideoSignatureTypesError: (state, action) => {
            const error = getError(action);
            const {key} = action.payload;

            state.videoSignatureTypes[key].state = STATE_ERROR;
            state.videoSignatureTypes[key].data = undefined;
            state.videoSignatureTypes[key].error = error;
        }
    }
});
